<div class="scd-wrap" role="dialog" aria-labelledby="scd-title" aria-modal="true">
  <!-- Header -->
  <div class="scd-header">
    <div>
      <div class="scd-eyebrow" aria-hidden="true">How it works</div>
      <h2 class="scd-title" id="scd-title">Handle in action</h2>
    </div>
    <button mat-icon-button (click)="close()" class="scd-close" aria-label="Close dialog">
      <mat-icon aria-hidden="true">close</mat-icon>
    </button>
  </div>

  <!-- Screenshot -->
  <div class="scd-image-wrap">
    <img
      [src]="screenshots[current].src"
      [attr.alt]="screenshots[current].label"
      class="scd-image"
      aria-live="polite"
      aria-atomic="true"
    />

    <button
      mat-icon-button
      class="scd-arrow scd-arrow-left"
      (click)="prev()"
      aria-label="Previous screenshot"
    >
      <mat-icon aria-hidden="true">chevron_left</mat-icon>
    </button>
    <button
      mat-icon-button
      class="scd-arrow scd-arrow-right"
      (click)="next()"
      aria-label="Next screenshot"
    >
      <mat-icon aria-hidden="true">chevron_right</mat-icon>
    </button>
  </div>

  <!-- Caption -->
  <div class="scd-caption" aria-live="polite" aria-atomic="true">
    <div class="scd-caption-label">{{ screenshots[current].label }}</div>
    <div class="scd-caption-text">{{ screenshots[current].caption }}</div>
  </div>

  <!-- Dots -->
  <div class="scd-dots" role="tablist" aria-label="Screenshot navigation">
    <button
      *ngFor="let s of screenshots; let i = index"
      class="scd-dot"
      role="tab"
      [class.active]="i === current"
      [attr.aria-selected]="i === current"
      [attr.aria-label]="'Go to screenshot ' + (i + 1) + ': ' + s.label"
      (click)="goTo(i)"
    ></button>
  </div>
</div>
